export default "__VITE_ASSET__Bf9AKef3__"